<template>
	<div v-if="costsTable" v-m2-span>
		<div class="d-flex align-center justify-space-between px-2 py-1" :class="{ 'white': projectContractClosed	}"
			v-if="projectContractClosed">
			<div class="d-flex flex-1 align-center">
				<v-chip
					:color="projectContractClosed ? 'warning' : 'green'"
					text-color="white"
					label
					class="mr-2 px-2">
					<p class="mb-0 font-weight-bold">{{ projectContractClosed ? 'Cerrada' : 'Abierta' }}</p>
				</v-chip>
				<div class="flex-1" style="color: orange" v-if="projectContractClosed">
					<p class="mb-0 caption font-weight-bold">{{ costTableTextTitle }} cerrada: <span class="mb-0 caption font-weight-normal">El {{ contractType.text	}} asociado a la tabla general de costo está <b>cerrado</b>.</span></p>
					<p class="mb-0 caption" v-if="hasAddendumWithCostTable">En la pestaña <b>Anexos</b> puedes editar la tabla de costo asociada al anexo de contrato vigente.</p>
					<p class="mb-0 caption" v-else-if="hasAddendumWithoutCostTable">Existe un anexo de contrato en proceso, pero no tiene tabla de costo asociada. Haz clic en 'Ir a Tabla de Costo' para acceder (se creará automáticamente si no existe).</p>
					<p class="mb-0 caption" v-else-if="canCreateAddendum">Para agregar nuevos elementos debes crear una nueva tabla de costo asociada a un anexo de contrato.</p>
					<p class="mb-0 caption" v-else>La Tabla de Costo está cerrada ya que el contrato asociado está con estado: <b>{{ contract?.last_status?.status | contractStatus }}</b></p>
				</div>
			</div>
			<div v-if="projectContractClosed && !fromModal && canCreateAddendum">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							depressed
							color="warning"
							height="32"
							:dark="!loadingCreateAddendum"
							:disabled="loadingCreateAddendum"
							:loading="loadingCreateAddendum"
							@click="createTableCostAddendum"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small>mdi-briefcase-outline</v-icon>
							<p class="mb-0 caption ml-2" v-if="hasAddendumWithCostTable">Editar Anexo Tabla de Costo</p>
							<p class="mb-0 caption ml-2" v-else-if="hasAddendumWithoutCostTable">Ir a Tabla de Costo</p>
							<p class="mb-0 caption ml-2" v-else>Crear Anexo y Tabla de Costo</p>
						</v-btn>
					</template>
					<span v-if="hasAddendumWithCostTable">Ir a la tabla de costo del anexo de contrato en proceso</span>
					<span v-else-if="hasAddendumWithoutCostTable">Ir a la tabla de costo del anexo (se creará automáticamente si no existe)</span>
					<span v-else>Crea una nueva tabla de costo y la asocia a un anexo</span>
				</v-tooltip>
			</div>
		</div>
		<v-simple-table style="zoom: 90%;">
			<template v-slot:default>
				<thead>
					<tr :style="{ backgroundColor: colors['costTablePrimaryColor'], color: calcFontColor(colors['costTablePrimaryColor']) }">
						<td style="vertical-align: middle;" colspan="8" :width="colWidths[0]" class="text-left pa-0">
							<div class="d-flex align-center justify-space-between">
								<div class="d-flex flex-1">
									<!-- <v-divider v-if="costTableBlocked" class="my-1" :style="{ borderColor: calcFontColor(colors['costTablePrimaryColor']) }"></v-divider> -->
									<div class="px-2 py-1 d-flex flex-1 align-center justify-space-between">
										<div class="d-flex flex-1" :class="projectContractClosed ? 'flex-column align-start justify-center' : 'flex-row align-center justify-start'">
											<v-chip
												v-if="!projectContractClosed"
												color="green"
												text-color="white"
												label
												class="mr-2 px-2">
												<p class="mb-0 font-weight-bold">{{ projectContractClosed ? 'Cerrada' : 'Abierta' }}</p>
											</v-chip>
											<p class="mb-0" style="font-size: 17px;" v-html="tableTitle"></p>
										</div>
										<div class="d-flex align-center" v-if="!fromModal">
											<v-chip
												v-if="projectContractClosed"
												color="#f2f2f2"
												text-color="black"
												label
												class="mr-2 px-2">
												<p class="mb-0" v-if="projectContractClosed">Valor UF Fijado: <b>${{costsTable.uf_value?.uf_value | toThousandFilter(2)}} - {{costsTable.uf_value?.date | toDate}}</b></p>
											</v-chip>
											<v-divider v-if="projectContractClosed" vertical class="mx-2" :style="{ borderColor: calcFontColor(colors['costTablePrimaryColor']) }"></v-divider>
											<CompanyTemplatesHandler
												v-if="!projectContractClosed && userResponsible"
												:type="'cost_table'"
												:itemContent="costTableElements"
												:color="calcFontColor(colors['costTablePrimaryColor'])"
												@template-content-selected="templateContentSelected"/>
											<v-divider v-if="!projectContractClosed && userResponsible" vertical class="mx-2" :style="{ borderColor: calcFontColor(colors['costTablePrimaryColor']) }"></v-divider>
											<div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															depressed
															:color="calcFontColor(colors['costTablePrimaryColor'])"
															dark
															icon
															class="mr-2"
															small
															@click="toContractDetail()"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon>{{ contractType.icon }}</v-icon>
														</v-btn>
													</template>
													<span>Ir al {{ contractType.text }} Asociado</span>
												</v-tooltip>
											</div>
											<div v-if="!(projectContractClosed || !userResponsible)">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															depressed
															:color="calcFontColor(colors['costTablePrimaryColor'])"
															dark
															icon
															class="mr-2"
															small
															v-if="userResponsible"
															@click="startDeleteContract()"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon>mdi-delete-outline</v-icon>
														</v-btn>
													</template>
													<span>Eliminar Tabla de Costo y Anexo</span>
												</v-tooltip>
											</div>
											<div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															depressed
															:color="calcFontColor(colors['costTablePrimaryColor'])"
															small
															icon
															class="mr-1"
															v-bind="attrs"
															v-on="on"
															@click.stop="openRelated"
														>
															<v-icon>mdi-eye</v-icon>
														</v-btn>
													</template>
													<span>Visualización Rápida Tablas Resumen</span>
												</v-tooltip>
											</div>

											<v-menu
												v-model="colorPickerVisible"
												:close-on-content-click="false"
												offset-x
											>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														depressed
														:color="calcFontColor(colors['costTablePrimaryColor'])"
														small
														v-bind="attrs"
														v-on="on"
													>
														<v-icon>mdi-palette</v-icon>
													</v-btn>
												</template>

												<v-card>
													<div>
														<div class="pa-2">
															<p class="mb-0 caption font-weight-bold">Selecciona Un Color a Editar</p>
															<p class="mb-1" style="font-size: 10px">Selecciona el color de la tabla que quieres modificar</p>
															<div class="d-flex align-center">
																<v-tooltip bottom
																			v-for="(colorVar, key) in colorVars"
																			:key="key">
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			depressed
																			color="white"
																			small
																			icon
																			v-bind="attrs"
																			v-on="on"
																			:style="{
																				border: activeColorKey === colorVar.value ? '2px solid #000' : '2px solid #cecece',
																				marginRight: '5px',
																				boxShadow: activeColorKey === colorVar.value ? '0 0 5px rgba(0,0,0,0.3)' : 'none'
																			}"
																			@click="openColorPicker(colorVar.value)"
																		>
																			<v-icon :color="colors[colorVar.value]">mdi-circle</v-icon>
																		</v-btn>
																	</template>
																	<span>{{colorVar.text}}</span>
																</v-tooltip>
															</div>
														</div>
														<v-color-picker
															v-model="currentColor"
															dot-size="25"
															hide-sliders
															mode="rgba"
															dense
															show-swatches
															swatches-max-height="100"
														/>
													</div>
													<v-card-actions>
														<v-spacer></v-spacer>
														<v-btn text @click="colorPickerVisible = false">Cerrar</v-btn>
													</v-card-actions>
												</v-card>
											</v-menu>
										</div>
									</div>
								</div>
							</div>
						</td>
					</tr>
				</thead>
			</template>
		</v-simple-table>
		<v-simple-table style="zoom: 90%" class="custom-table-cost caption" :class="{ 'blocked-content-cost-table': costTableBlocked }">
			<template v-slot:default>
				<!-- Start Main Project -->
				<tbody style="border-bottom: 2px solid white;">
					<tr :style="{ backgroundColor: colors['costTableSectionsMain'], color: calcFontColor(colors['costTableSectionsMain']) }">
						<td style="vertical-align: middle;" rowspan="10000" class="force-open-cell" :class="{ 'block-content-background': costTableBlocked	}">
							<div class="d-flex align-start justify-space-between flex-1">
								<div class="px-2" style="width: 100%;">
									<div class="d-flex flex-column align-start" style="font-size: 12px;" :class="{ 'blocked-content': costTableBlocked	}">
										<p class="mb-0" style="font-size: 10px;">{{ projectTypeSubtitle }}</p>
										<p class="mb-0" :key="projectTypeTitle">{{projectTypeTitle}}</p>
									</div>
									<v-divider class="my-2" :style="{ borderColor: calcFontColor(colors['costTableSectionsMain']) }" style="opacity: 0.4"></v-divider>
									<p class="mb-0 font-weight-bold" v-if="costTableTitle">{{ costTableTitle }}</p>
									<div v-else-if="!projectContractClosed" class="no-costs-table-title-container">
										<v-alert
											color="white"
											dense
											border="left"
										>
											<div class="d-flex align-center mb-1" style="gap: 10px; color: orange;">
												<v-icon small color="orange">mdi-information</v-icon>
												<p class="mb-0 caption font-weight-bold">Tabla de Costo sin Título</p>
											</div>
											<div style="color: orange;">
												<p class="mb-0 caption">Por favor ingresa un título descriptivo de la tabla de costo para activarla</p>
											</div>
											<CostTableInfoConfig
												style="margin-top: 4px;"
												:project="project"
												:costsTable="costsTable"
												color="orange"
												:buttonBig="true"
											/>
										</v-alert>
									</div>
								</div>
								<CostTableInfoConfig
									style="margin-top: 2px;"
									:project="project"
									:costsTable="costsTable"
									:color="calcFontColor(colors['costTableSectionsMain'])"
									:fromModal="fromModal"
									v-if="!costTableBlocked"
								/>
							</div>
						</td>
					</tr>
					
					<tr class="header-rows-custom" :style="{ backgroundColor: colors['costTableSecondaryColor'], color: calcFontColor(colors['costTableSecondaryColor']) }">
						<td style="vertical-align: middle;" :width="colWidths[0]" class="text-left">
							<p class="mb-0 font-weight-bold caption">Superficie a Desarrollar</p>
						</td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]"><p class="text-right mb-0 caption font-weight-bold" >Superficie <span class="m2-lower">m²</span></p></td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]"><p class="text-right mb-0 caption font-weight-bold" >Valor x <span class="m2-lower">m²</span> (UF)</p></td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]"><p class="text-right mb-0 caption font-weight-bold" >Valor x <span class="m2-lower">m²</span> (CLP)</p></td>
						<td style="vertical-align: middle;" :width="colWidths[4]"><p class="text-right mb-0 caption font-weight-bold" >Total UF</p></td>
						<td style="vertical-align: middle;" :width="colWidths[5]"><p class="text-right mb-0 caption font-weight-bold" >Total CLP</p></td>
						<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 caption font-weight-bold" ></p></td>
					</tr>

					<CostItemContainer
						:costItems="costsTable.surfaces?.items || []"
						:ufValue="ufValue"
						:colWidths="colWidths"
						:isM2Selection="true"
						:m2SelectionType="2"
						:showSubitems="false"
						:currency="currency"
						@update:costItems="handleUpdateSurfaceItems"/>

					<tr class="header-rows-custom" :style="{ backgroundColor: colors['costTableSecondaryColor'], color: calcFontColor(colors['costTableSecondaryColor']) }">
						<td style="vertical-align: middle;" :width="colWidths[0]" class="text-left">
							<p class="mb-0 font-weight-bold caption">Detalle Proyecto</p>
						</td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]"><p class="text-right mb-0 caption font-weight-bold" >Cantidad</p></td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]"><p class="text-right mb-0 caption font-weight-bold" >Precio Unitario (UF)</p></td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]"><p class="text-right mb-0 caption font-weight-bold" >Precio Unitario (CLP)</p></td>
						<td style="vertical-align: middle;" :width="colWidths[4]"><p class="text-right mb-0 caption font-weight-bold" >Total UF</p></td>
						<td style="vertical-align: middle;" :width="colWidths[5]"><p class="text-right mb-0 caption font-weight-bold" >Total CLP</p></td>
						<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 caption font-weight-bold" ></p></td>
					</tr>

					<CostItemContainer
						:costItems="costsTable.items"
						:costCategoriesConfig="cost_categories_config"
						:costStageType="1"
						:ufValue="ufValue"
						:colWidths="colWidths"
						:itemLevel="1"
						:currency="currency"
						@update:costItems="handleUpdateCostItems"/>
				</tbody>
				<tbody style="border-bottom: 2px solid white;">
					<tr :style="{ backgroundColor: colors['costTableFourthColor'], color: calcFontColor(colors['costTableFourthColor']) }">
						<td style="vertical-align: middle;" colspan="5"><p class="text-right mb-0 font-weight-bold">Subtotal Neto</p></td>
						<td style="vertical-align: middle;" :width="colWidths[4]">
							<div>
								<p class="mb-0 text-right" >UF</p>
								<p class="text-right mb-0 font-weight-bold body-1">{{ detailTotalCostSummary.total_cost_uf | toThousandFilter(2) }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;" :width="colWidths[5]">
							<div>
								<p class="mb-0 text-right" >CLP</p>
							<p class="text-right mb-0 font-weight-bold body-1">${{ detailTotalCostSummary.total_cost_clp | toThousandFilter }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 font-weight-bold caption"></p></td>
					</tr>
				</tbody>
				<!-- End Main Project -->

				<!-- Start Stages -->
				<tbody style="border-bottom: 2px solid white;">
					<tr :style="{ backgroundColor: colors['costTableSectionsStages'], color: calcFontColor(colors['costTableSectionsStages']) }">
						<td style="vertical-align: middle;" rowspan="10000" :class="{ 'block-content-background': costTableBlocked	}">
							<div class="d-flex flex-column align-start pa-2">
								<p class="mb-1 font-weight-bold">Posibles Etapas</p>
								<v-btn
									outlined
									depressed
									:color="calcFontColor(colors['costTableSectionsStages'])"
									x-small
									@click="handleAddStage"
								>
									<v-icon small>mdi-plus</v-icon>
									<p class="mb-0">Agregar Etapa</p>
								</v-btn>
							</div>
						</td>
					</tr>
					<tr v-if="costsTable.stages.length > 0" class="header-rows-custom" :style="{ backgroundColor: colors['costTableSecondaryColor'], color: calcFontColor(colors['costTableSecondaryColor']) }">
						<td style="vertical-align: middle;" :width="colWidths[0]" class="text-left">
							<p class="mb-0 font-weight-bold caption">Detalle Proyecto</p>
						</td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]"><p class="text-right mb-0 caption font-weight-bold" >Cantidad</p></td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]"><p class="text-right mb-0 caption font-weight-bold" >Precio Unitario (UF)</p></td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]"><p class="text-right mb-0 caption font-weight-bold" >Precio Unitario (CLP)</p></td>
						<td style="vertical-align: middle;" :width="colWidths[4]"><p class="text-right mb-0 caption font-weight-bold" >Total UF</p></td>
						<td style="vertical-align: middle;" :width="colWidths[5]"><p class="text-right mb-0 caption font-weight-bold" >Total CLP</p></td>
						<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 caption font-weight-bold" ></p></td>
					</tr>
					<tr v-else class="header-rows-custom" :style="{ backgroundColor: colors['costTableSecondaryColor'], color: calcFontColor(colors['costTableSecondaryColor']) }">
						<td style="vertical-align: middle;" :width="colWidths[0]" colspan="7" class="text-left">
							<p class="mb-0 font-weight-bold caption"></p>
						</td>
					</tr>
					<CostItemContainerStages
						v-for="(stage, index) in costsTable.stages"
						:key="stage.id"
						:costItems="stage"
						:costCategoriesConfig="cost_categories_config"
						:ufValue="ufValue"
						:colWidths="colWidths"
						:itemLevel="1"
						:currency="currency"
						@update:costItems="(val) => handleUpdateStage(val, index)"
						:class="getBlockedItemsClass(stage)"
					/>
				</tbody>
				<tbody style="border-bottom: 2px solid white;">
					<tr v-if="costsTable.stages.length > 0" :style="{ backgroundColor: colors['costTableFourthColor'], color: calcFontColor(colors['costTableFourthColor']) }">
						<td style="vertical-align: middle;" colspan="5"><p class="text-right mb-0 font-weight-bold">Subtotal Neto</p></td>
						<td style="vertical-align: middle;" :width="colWidths[4]">
							<div>
								<p class="mb-0 text-right caption" >UF</p>
								<p class="text-right mb-0 font-weight-bold body-1">{{ stageTotalCostSummary.total_cost_uf | toThousandFilter(2) }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;" :width="colWidths[5]">
							<div>
								<p class="mb-0 text-right caption" >CLP</p>
							<p class="text-right mb-0 font-weight-bold body-1">${{ stageTotalCostSummary.total_cost_clp | toThousandFilter }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 font-weight-bold caption"></p></td>
					</tr>
				</tbody>
				<!-- End Stages -->

				<!-- Start Reception -->
				<template v-if="canShowReceptionSection">
					<tbody style="border-bottom: 2px solid white;">
						<tr ref="receptionSection" :style="{ backgroundColor: colors['costTableSectionsReception'], color: calcFontColor(colors['costTableSectionsReception']) }">
							<td style="vertical-align: middle;" rowspan="10000" :class="{ 'block-content-background': costTableBlocked	}">
								<div class="d-flex flex-column align-start pa-2">
									<p class="mb-1 font-weight-bold">Recepción Final</p>
									<div v-if="costsTable.reception">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													dark
													outlined
													x-small
													:color="calcFontColor(colors['costTableSectionsReception'])"
													@click="handleRemoveReception"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small dark>mdi-delete-outline</v-icon>
													<p class="mb-0">Eliminar Recepción</p>
												</v-btn>
											</template>
											<span>Eliminar Recepción Final</span>
										</v-tooltip>
									</div>
									<div v-else>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													dark
													outlined
													x-small
													:color="calcFontColor(colors['costTableSectionsReception'])"
													@click="handleAddReception"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small>mdi-plus</v-icon>
													<p class="mb-0">Incluir Recepción</p>
												</v-btn>
											</template>
											<span>Incluir Recepción Final</span>
										</v-tooltip>
									</div>
								</div>
							</td>
						</tr>
						<tr v-if="costsTable.reception" class="header-rows-custom" :style="{ backgroundColor: colors['costTableSecondaryColor'], color: calcFontColor(colors['costTableSecondaryColor']) }">
							<td style="vertical-align: middle;" :width="colWidths[0]" class="text-left">
								<p class="mb-0 font-weight-bold caption">Detalle Proyecto</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]"><p class="text-right mb-0 caption font-weight-bold" >Cantidad</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]"><p class="text-right mb-0 caption font-weight-bold" >Precio Unitario (UF)</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]"><p class="text-right mb-0 caption font-weight-bold" >Precio Unitario (CLP)</p></td>
							<td style="vertical-align: middle;" :width="colWidths[4]"><p class="text-right mb-0 caption font-weight-bold" >Total UF</p></td>
							<td style="vertical-align: middle;" :width="colWidths[5]"><p class="text-right mb-0 caption font-weight-bold" >Total CLP</p></td>
							<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 caption font-weight-bold" ></p></td>
						</tr>
						<tr v-else class="header-rows-custom" :style="{ backgroundColor: colors['costTableSecondaryColor'], color: calcFontColor(colors['costTableSecondaryColor']) }">
							<td style="vertical-align: middle;" :width="colWidths[0]" colspan="7" class="text-left">
								<p class="mb-0 font-weight-bold caption"></p>
							</td>
						</tr>
						<CostItemContainer
							v-if="costsTable.reception"
							:costItems="costsTable.reception?.items || []"
							:costCategoriesConfig="cost_categories_config"
							:costStageType="3"
							:ufValue="ufValue"
							:colWidths="colWidths"
							:itemLevel="0"
							:currency="currency"
							@update:costItems="handleUpdateReception"
							:class="getBlockedItemsClass(costsTable.reception)"/>
					</tbody>
					<tbody style="border-bottom: 2px solid white;">
						<tr v-if="costsTable.reception" :style="{ backgroundColor: colors['costTableFourthColor'], color: calcFontColor(colors['costTableFourthColor']) }">
							<td style="vertical-align: middle;" colspan="5"><p class="text-right mb-0 font-weight-bold">Subtotal Neto</p></td>
							<td style="vertical-align: middle;" :width="colWidths[4]">
								<div>
									<p class="mb-0 text-right caption" >UF</p>
									<p class="text-right mb-0 font-weight-bold body-1">{{ receptionTotalCostSummary.total_cost_uf | toThousandFilter(2) }}</p>
								</div>
							</td>
							<td style="vertical-align: middle;" :width="colWidths[5]">
								<div>
									<p class="mb-0 text-right caption" >CLP</p>
								<p class="text-right mb-0 font-weight-bold body-1">${{ receptionTotalCostSummary.total_cost_clp | toThousandFilter }}</p>
								</div>
							</td>
							<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 font-weight-bold caption"></p></td>
						</tr>
					</tbody>
				</template>
				<!-- End Reception -->

				<!-- Start Specialties -->
				<tbody style="border-bottom: 2px solid white;">
					<tr :style="{ backgroundColor: colors['costTableSectionsSpecialties'], color: calcFontColor(colors['costTableSectionsSpecialties']) }">
						<td style="vertical-align: middle;" rowspan="10000" :class="{ 'block-content-background': costTableBlocked	}">
							<div class="d-flex flex-column align-start pa-2">
								<p class="mb-1 font-weight-bold">Proyectos / Especialidades</p>
								<v-btn
									outlined
									depressed
									:color="calcFontColor(colors['costTableSectionsSpecialties'])"
									x-small
									@click="handleAddSpecialty"
								>
									<v-icon small>mdi-plus</v-icon>
									<p class="mb-0">Agregar Proyecto / Especialidad</p>
								</v-btn>
							</div>
						</td>
					</tr>
					<tr v-if="costsTable.specialties.length > 0" class="header-rows-custom" :style="{ backgroundColor: colors['costTableSecondaryColor'], color: calcFontColor(colors['costTableSecondaryColor']) }">
						<td style="vertical-align: middle;" :width="colWidths[0]" class="text-left">
							<p class="mb-0 font-weight-bold caption">Detalle Proyecto</p>
						</td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]"><p class="text-right mb-0 caption font-weight-bold" >Cantidad</p></td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]"><p class="text-right mb-0 caption font-weight-bold" >Precio Unitario (UF)</p></td>
						<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]"><p class="text-right mb-0 caption font-weight-bold" >Precio Unitario (CLP)</p></td>
						<td style="vertical-align: middle;" :width="colWidths[4]"><p class="text-right mb-0 caption font-weight-bold" >Total UF</p></td>
						<td style="vertical-align: middle;" :width="colWidths[5]"><p class="text-right mb-0 caption font-weight-bold" >Total CLP</p></td>
						<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 caption font-weight-bold" ></p></td>
					</tr>
					<tr v-else class="header-rows-custom" :style="{ backgroundColor: colors['costTableSecondaryColor'], color: calcFontColor(colors['costTableSecondaryColor']) }">
						<td style="vertical-align: middle;" :width="colWidths[0]" colspan="7" class="text-left">
							<p class="mb-0 font-weight-bold caption"></p>
						</td>
					</tr>
					<CostItemContainerSpecialties
						v-for="(specialty, index) in costsTable.specialties"
						:key="specialty.id"
						:costItems="specialty"
						:costCategoriesConfig="cost_categories_config"
						:ufValue="ufValue"
						:colWidths="colWidths"
						:itemLevel="1"
						:currency="currency"
						@update:costItems="(val) => handleUpdateSpecialty(val, index)"
						:class="getBlockedItemsClass(specialty)"
					/>
				</tbody>
				<tbody style="border-bottom: 2px solid white;">
					<tr v-if="costsTable.specialties.length > 0" :style="{ backgroundColor: colors['costTableFourthColor'], color: calcFontColor(colors['costTableFourthColor']) }">
						<td style="vertical-align: middle;" colspan="5"><p class="text-right mb-0 font-weight-bold">Subtotal Neto</p></td>
						<td style="vertical-align: middle;" :width="colWidths[4]">
							<div>
								<p class="mb-0 text-right caption" >UF</p>
								<p class="text-right mb-0 font-weight-bold body-1">{{ specialtiesTotalCostSummary.total_cost_uf | toThousandFilter(2) }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;" :width="colWidths[5]">
							<div>
								<p class="mb-0 text-right" >CLP</p>
							<p class="text-right mb-0 font-weight-bold body-1">${{ specialtiesTotalCostSummary.total_cost_clp | toThousandFilter }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;" :width="colWidths[6]"><p class="text-right mb-0 font-weight-bold caption"></p></td>
					</tr>
				</tbody>

				<tbody>
					<tr :style="{ backgroundColor: colors['costTablePrimaryColor'], color: calcFontColor(colors['costTablePrimaryColor']) }">
						<td style="vertical-align: middle;height:auto;" colspan="5"></td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[4]">
							<div>
								<p class="mb-0 text-right caption font-weight-bold" >UF</p>
							</div>
						</td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[5]">
							<div>
								<p class="mb-0 text-right caption font-weight-bold" >CLP</p>
							</div>
						</td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[6]"><p class="text-right mb-0 font-weight-bold caption"></p></td>
					</tr>
					<tr :style="{ backgroundColor: colors['costTablePrimaryColor'], color: calcFontColor(colors['costTablePrimaryColor']) }">
						<td style="vertical-align: middle;height:auto;" colspan="5"><p class="text-right mb-0 font-weight-bold">Total Neto</p></td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[4]">
							<div>
								<p class="text-right mb-0 font-weight-bold body-1">{{ totalProjectCostSummary.total_cost_uf | toThousandFilter(2) }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[5]">
							<div>
							<p class="text-right mb-0 font-weight-bold body-1">${{ totalProjectCostSummary.total_cost_clp | toThousandFilter }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[6]"><p class="text-right mb-0 font-weight-bold caption"></p></td>
					</tr>
					<tr :style="{ backgroundColor: colors['costTablePrimaryColor'], color: calcFontColor(colors['costTablePrimaryColor']) }">
						<td style="vertical-align: middle;height:auto;" colspan="5"><p class="text-right mb-0 font-weight-bold">Impuesto ({{ costsTable.tax?.value }}%)</p></td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[4]">
							<div>
								<p class="text-right mb-0 font-weight-bold body-1">{{ totalProjectCostSummary.tax_value_uf | toThousandFilter(2) }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[5]">
							<div>
							<p class="text-right mb-0 font-weight-bold body-1">${{ totalProjectCostSummary.tax_value_clp | toThousandFilter }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[6]"><p class="text-right mb-0 font-weight-bold caption"></p></td>
					</tr>
					<tr :style="{ backgroundColor: colors['costTablePrimaryColor'], color: calcFontColor(colors['costTablePrimaryColor']) }">
						<td style="vertical-align: middle;height:auto;" colspan="5"><p class="text-right mb-0 font-weight-bold">Total con Impuesto</p></td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[4]">
							<div>
								<p class="text-right mb-0 font-weight-bold body-1">{{ totalProjectCostSummary.total_cost_uf_taxed | toThousandFilter(2) }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[5]">
							<div>
							<p class="text-right mb-0 font-weight-bold body-1">${{ validatedTotal | toThousandFilter }}</p>
							</div>
						</td>
						<td style="vertical-align: middle;height:auto;" :width="colWidths[6]"><p class="text-right mb-0 font-weight-bold caption"></p></td>
					</tr>
				</tbody>
				<TableCostTotals
					v-if="isLastItem && parentCostsTable"
					:costsTable="parentCostsTable"
					:colors="colors"
					:colWidths="colWidths"/>
			</template>
		</v-simple-table>
	</div>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

import { contractStatuses } from '@/components/Helpers/Constants/contract.js'
import { getParentItemTotalValueMultiWithTax } from '@/helpers/tablecostHelpers.js'

import { addContractAddendum, deleteContractAddendum } from '@/helpers/api/contracts'
import { getProjectCostDetail } from '@/helpers/api/costs'

import CompanyTemplatesHandler from '@/components/Helpers/Components/CompanyTemplatesHandler'
import CostTableInfoConfig from '@/components/Views/Projects/SettingsParts/CostTableInfoConfig'
import CostItemContainer from '../Parts/CostItemContainer.vue'
import CostItemContainerStages from '../Parts/CostItemContainerStages.vue'
import CostItemContainerSpecialties from '../Parts/CostItemContainerSpecialties.vue'
import TableCostTotals from '@/components/Views/Projects/TableCostParts/TableCostTotals.vue'

export default {
  name: 'GeneralTableCost',

  components: {
		CompanyTemplatesHandler,
		CostTableInfoConfig,
    CostItemContainer,
    CostItemContainerStages,
    CostItemContainerSpecialties,
		TableCostTotals
  },

  props: {
		// tableTitle: {
		// 	type: String,
		// 	default: 'Tabla General de Costos'
		// },
		fromModal: {
			type: Boolean,
			default: false
		},
		parentCostsTable: {
			type: Object,
			required: false
		},
    costsTable: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
		contract: {
			type: Object,
			required: true
		},
		cost_categories_config: {
			type: Array,
			required: false
		},
    colors: {
      type: Object,
      required: true
    },
    colorVars: {
      type: Array,
      default: () => []
    },
    ufValueBase: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      default: 'uf'
    },
    costCategoriesConfig: {
      type: Array,
      default: () => []
    },
    colWidths: {
      type: Array,
      default: () => ['30%','10%','10%','15%','12%','15%','8%']
    },
    canShowReceptionSection: {
      type: Boolean,
      default: false
    },
    allowEdit: {
      type: Boolean,
      default: true
    },
		addStage: {
			type: Function,
			required: false
		},
		addProject: {
			type: Function,
			required: false
		},
		removeProject: {
			type: Function,
			required: false
		},
		onChangeSecondaryCostProject: {
			type: Function,
			required: false
		},
		onChangeSecondaryCostProjectItem: {
			type: Function,
			required: false
		},
		updateStage: {
			type: Function,
			required: false
		},
		addReception: {
			type: Function,
			required: false
		},
		updateReception: {
			type: Function,
			required: false
		},
		addSpecialty: {
			type: Function,
			required: false
		},
		updateSpecialty: {
			type: Function,
			required: false
		},
		removeReception: {
			type: Function,
			required: false
		},
		updateSurfaceItems: {
			type: Function,
			required: false
		},
		updateCostItems: {
			type: Function,
			required: false
		},
		selectedUfValue: {
			type: Object,
			required: false
		},
		isLastItem: {
			type: Boolean,
			default: false
		}
  },

  data() {
    return {
			contractStatuses,
      activeColorKey: 'costTablePrimaryColor',
			colorPickerVisible: false,
			loading: false,
			loadingCreateAddendum: false
    }
  },

  computed: {
		validatedTotal() {
			const mathTotalClp = Math.round(parseFloat(this.totalProjectCostSummary.total_cost_clp) || 0)
			const mathTotalTaxClp = Math.round(parseFloat(this.totalProjectCostSummary.tax_value_clp) || 0)
			const total = mathTotalClp + mathTotalTaxClp
			return total
		},
		ufValue(){
			return this.costsTable.uf_value?.uf_value || this.selectedUfValue?.value || 0
		},
		costTableElements(){
			const surfaces = this.costsTable.surfaces?.items?.map(item => ({
				id: null,
				name: item.name,
				qty: item.qty,
				unit_cost_uf: item.unit_cost_uf,
				unit_cost_clp: item.unit_cost_clp
			})) || [];
			const stages = this.costsTable.stages?.map(item => ({
				id: null,
				stage_id: item.stage?.id,
				stage: item.stage,
				items: item.items?.map(stageItem => ({
					name: stageItem.name,
					qty: stageItem.qty,
					unit_cost_uf: stageItem.unit_cost_uf,
					unit_cost_clp: stageItem.unit_cost_clp,
					subitems: item.subitems?.map(subitem => ({
						name: subitem.name,
						qty: subitem.qty,
						unit_cost_uf: subitem.unit_cost_uf,
						unit_cost_clp: subitem.unit_cost_clp
					}))
				}))
			})) || [];
			const items = this.costsTable.items?.map(item => ({
				id: null,
				name: item.name,
				qty: item.qty,
				unit_cost_uf: item.unit_cost_uf,
				unit_cost_clp: item.unit_cost_clp,
				subitems: item.subitems?.map(subitem => ({
					name: subitem.name,
					qty: subitem.qty,
					unit_cost_uf: subitem.unit_cost_uf,
					unit_cost_clp: subitem.unit_cost_clp
				}))
			})) || [];
			const reception = this.costsTable.reception ? {
				id: null,
				name: this.costsTable.reception.name,
				qty: this.costsTable.reception.qty,
				unit_cost_uf: this.costsTable.reception.unit_cost_uf,
				unit_cost_clp: this.costsTable.reception.unit_cost_clp,
				items: this.costsTable.reception.items?.map(item => ({
					name: item.name,
					qty: item.qty,
					unit_cost_uf: item.unit_cost_uf,
					unit_cost_clp: item.unit_cost_clp,
					subitems: item.subitems?.map(subitem => ({
						name: subitem.name,
						qty: subitem.qty,
						unit_cost_uf: subitem.unit_cost_uf,
						unit_cost_clp: subitem.unit_cost_clp
					}))
				}))
			} : null;
			const specialties = this.costsTable.specialties?.map(item => ({
				id: null,
				company_specialty_id: item.specialty?.id,
				specialty: item.specialty,
				qty: item.qty,
				unit_cost_uf: item.unit_cost_uf,
				unit_cost_clp: item.unit_cost_clp,
				items: item.items?.map(specialtyItem => ({
					name: specialtyItem.name,
					qty: specialtyItem.qty,
					unit_cost_uf: specialtyItem.unit_cost_uf,
					unit_cost_clp: specialtyItem.unit_cost_clp,
					subitems: item.subitems?.map(subitem => ({
						name: subitem.name,
						qty: subitem.qty,
						unit_cost_uf: subitem.unit_cost_uf,
						unit_cost_clp: subitem.unit_cost_clp
					}))
				}))
			})) || [];
			return {
				surfaces,
				stages,
				items,
				reception,
				specialties,
			}
		},
		userResponsible(){
			return this.$store.state.user?.userInfo?.id == this.project?.responsible_id
		},
		costTableTextTitle(){
			if(this.isTableForAddendum){
				return `Tabla de costo para anexo`
			}
			return `Tabla general de costo`
		},
    contractType(){
			if(this.contract?.addendum_to_contract_id){
				return {'text': 'Anexo de Contrato', 'icon': 'mdi-briefcase-plus-outline'}
			}
			return {'text': 'Contrato', 'icon': 'mdi-briefcase-outline'}
		},
		openAddendum(){
			const addendum = this.contract.addendums?.find(addendum => addendum.last_status?.status < contractStatuses.FIRMADO_CONTRAPARTE)
			const addendum_cost_table = this.costsTable.project_tables?.find(ptable => ptable.contract?.addendum_to_contract_id == this.contract.id)
			return addendum && addendum_cost_table
		},
		hasAddendumWithoutCostTable(){
			const addendum = this.contract.addendums?.find(addendum => addendum.last_status?.status < contractStatuses.FIRMADO_CONTRAPARTE)
			const addendum_cost_table = this.costsTable.project_tables?.find(ptable => ptable.contract?.addendum_to_contract_id == this.contract.id)
			return addendum && !addendum_cost_table
		},
		hasAddendumWithCostTable(){
			return !!this.openAddendum
		},
		noAddendum(){
			return !this.contract.addendums?.length
		},
		costTableBlocked(){
			// return false
			return this.projectContractClosed || !this.costTableTitle || !this.userResponsible
		},
		costTableTitle(){
			// return null
			return this.costsTable.project_cost_info?.title
		},
		canCreateAddendum(){
			return this.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES
		},
		projectContractClosed(){
			const statusesBlocked = [
				contractStatuses.ENVIADO_CONTRAPARTE,
				contractStatuses.ACEPTADO,
				contractStatuses.RECHAZADO,
				contractStatuses.FIRMADO_CONTRAPARTE,
				contractStatuses.FIRMADO_AMBAS_PARTES,
			]
			return statusesBlocked.includes(this.contract?.last_status?.status)
		},
		isTableForAddendum(){
			return !!this.contract?.addendum_to_contract_id
		},
		projectTypeTitle() {
			return this.costsTable?.contract?.info?.project_type?.name || this.project?.info?.project_type?.name || 'Tipo de Proyecto No Definido';
		},
		projectTypeSubtitle() {
			const parentName = this.costsTable?.contract?.info?.project_type?.parent?.name || this.project?.info?.project_type?.parent?.name || '';
			const categoryName = this.costsTable?.contract?.info?.project_type?.category?.name || this.project?.info?.project_type?.category?.name || '';
			
			if (parentName && categoryName) {
				return `${categoryName} | ${parentName}`;
			}
			return parentName || categoryName || '';
		},
		secondaryTablesSurfacesItems() {
			if(!this.costsTable || !this.costsTable.project_tables) return []
			return this.costsTable.project_tables.map(project => project.surfaces?.items || [])
		},
		// tableTitle() {
		// 	if(this.contract) {
		// 		const contract = this.contract
		// 		if(contract.addendum_index){
		// 			return `Anexo Tabla de Costos`	
		// 		}
		// 		return `Tabla General de Costos`
		// 	}
		// 	return 'Tabla General de Costos'
		// },
		tableTitle() {
			if(this.contract) {
				const contract = this.contract
				if(contract.addendum_index){
					return `Tabla de costo correspondiente al anexo: <b>${this.contractCode}</b>`		
				}
				return `Tabla de costo correspondiente al contrato: <b>${this.contractCode}</b>`
			}
			return 'Tabla General de Costos'
		},
		contractCode() {
			const contract = this.contract
			if(contract?.parent_contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.parent_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		currentColor: {
			get() {
				return this.colors[this.activeColorKey]
			},
			set(value) {
				this.$store.commit('costbreakdown/setCostTableColorMap', {
					[this.activeColorKey]: value
				});
			}
		},
    hasSecondaryProjects() {
      return Array.isArray(this.costsTable?.projects) && this.costsTable.projects.length > 0
    },
		totalProjectCostSummary() {
			const allSections = [
				this.costsTable.surfaces,
				{items: this.costsTable.items},
				...this.costsTable.stages.filter(st => st.active),
				...this.costsTable.specialties,
				...this.costsTable.projects,
				this.costsTable.reception
			].filter(Boolean);
			return getParentItemTotalValueMultiWithTax(allSections, this.costsTable.tax || 0, this.costsTable.uf_value?.uf_value || this.selectedUfValue?.value || 0);
		},
		detailTotalCostSummary() {
			return getParentItemTotalValueMultiWithTax([this.costsTable.surfaces, {items: this.costsTable.items}], this.costsTable.tax || 0, this.costsTable.uf_value?.uf_value || this.selectedUfValue?.value || 0);
		},
		costAllProjectsTotalSummary() {
			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};

			if (Array.isArray(this.costsTable.projects)) {
				this.costsTable.projects.forEach((project, index) => {
					const projectTotals = this.costProjectDetailTotalCostSummary(index);

					totals.qty += projectTotals.qty;
					totals.unit_cost_uf += projectTotals.unit_cost_uf;
					totals.unit_cost_clp += projectTotals.unit_cost_clp;
					totals.total_cost_uf += Math.round(projectTotals.total_cost_uf);
					totals.total_cost_clp += Math.round(projectTotals.total_cost_clp);
				});
			}

			return totals;
		},
		stageTotalCostSummary() {
			return getParentItemTotalValueMultiWithTax(this.costsTable.stages || [], this.costsTable.tax || 0, this.costsTable.uf_value?.uf_value || this.selectedUfValue?.value || 0);
		},
		specialtiesTotalCostSummary() {
			return getParentItemTotalValueMultiWithTax(this.costsTable.specialties || [], this.costsTable.tax || 0, this.costsTable.uf_value?.uf_value || this.selectedUfValue?.value || 0);
		},
		projectsTotalCostSummary() {
			return getParentItemTotalValueMultiWithTax(this.costsTable.projects || [], this.costsTable.tax || 0, this.costsTable.uf_value?.uf_value || this.selectedUfValue?.value || 0);
		},
		stagesTotalCost(){
			let total = 0;

			if (Array.isArray(this.costsTable.stages)) {
				for (const stage of this.costsTable.stages) {
					if (Array.isArray(stage.items)) {
						for (const item of stage.items) {
							total += (item.qty || 0) * (item.unit_cost_uf || 0);

							if (Array.isArray(item.subitems)) {
								for (const subitem of item.subitems) {
									total += (subitem.qty || 0) * (subitem.unit_cost_uf || 0);
								}
							}
						}
					}
				}
			}

			return total;
		},
		receptionTotalCostSummary() {
			const result = getParentItemTotalValueMultiWithTax(this.costsTable.reception ? [this.costsTable.reception] : [], this.costsTable.tax || 0, this.costsTable.uf_value?.uf_value || this.selectedUfValue?.value || 0);
			return {
				qty: Math.round(result.qty * 100) / 100,
				unit_cost_uf: Math.round(result.unit_cost_uf * 100) / 100,
				unit_cost_clp: Math.round(result.unit_cost_clp * 100) / 100,
				total_cost_uf: Math.round(result.total_cost_uf * 100) / 100,
				total_cost_clp: Math.round(result.total_cost_clp * 100) / 100,
				total_cost_uf_taxed: Math.round(result.total_cost_uf_taxed * 100) / 100,
				tax_value_uf: Math.round(result.tax_value_uf * 100) / 100,
				total_cost_clp_taxed: Math.round(result.total_cost_clp_taxed * 100) / 100,
				tax_value_clp: Math.round(result.tax_value_clp * 100) / 100,
			};
		},

    requiredRule() {
      return [(v) => !!v || 'Este campo es requerido']
    }
  },
  methods: {
		templateContentSelected(template){
      this.$emit('update:costsTable', template)
		},
		toContractDetail(){
			const contract = this.contract
			if(!contract || !contract.id) return;
			localStorage.setItem('last_working_contract', JSON.stringify(contract))

			const screenWidth = window.screen.width;
			const screenHeight = window.screen.height;
			const finalWidth = Math.min(1000, screenWidth);
			
			if(contract.addendum_to_contract_id){
				window.open(
					`/built-in-content?type=addendum&id=${contract.id}`,
					'',
					`width=${finalWidth},height=${screenHeight * 0.9},right=0,top=0,toolbar=no,menubar=no,location=no,status=no`
				)
				return null
			}
			window.open(
				`/built-in-content?type=contract&id=${contract.id}`,
				'',
				`width=${finalWidth},height=${screenHeight * 0.9},right=0,top=0,toolbar=no,menubar=no,location=no,status=no`
			)
		},
		getBlockedItemsClass(item){
			if(!item.id){
				return 'blocked-content-cost-table'
			}
		},
		openRelated(){
			if(this.parentCostsTable){
				this.$store.commit('costbreakdown/setCostBreakdownMainTableModal', true)
			}
			else{
				this.$store.commit('costbreakdown/setCostBreakdownSummaryTablesModal', true)
			}
		},
		toggleShowRelatedTables(){
			const data = {
				selected_uf_value: this.selectedUfValue,
				project: this.project,
				colors: this.colors,
				colorVars: this.colorVars,
				ufValue: this.ufValue,
				currency: this.currency,
				colWidths: this.colWidths,
				canShowReceptionSection: this.canShowReceptionSection,
				cost_categories_config: this.cost_categories_config,
				project_tables: this.costsTable.project_tables
			}
			this.$store.commit('costbreakdown/setModalProjectTables', data)
			this.$store.commit('costbreakdown/setShowModalProjectTables', true)
		},
    updateColor(colorData) {
      this.$emit('update:colors', colorData)
    },

    changeActiveColor(key) {
      this.activeColorKey = key
    },

    costProjectDetailTotalCostSummary(projectIndex) {
      let total_cost_uf = 0
      let total_cost_clp = 0

      if (this.costsTable?.projects?.[projectIndex]?.items) {
        this.costsTable.projects[projectIndex].items.forEach(item => {
          total_cost_uf += item.total_cost_uf || 0
          total_cost_clp += item.total_cost_clp || 0
        })
      }

      return {
        total_cost_uf: Number(total_cost_uf.toFixed(2)),
        total_cost_clp: Math.round(total_cost_clp)
      }
    },
		async startDeleteContract(){
			const confirmed = await confirm('Esto eliminará la Tabla de Costo y el Contrato de Anexo asociado. ¿Estás seguro de que deseas continuar?')
			if(confirmed){
				this.destroyContractAddendum()
			}
		},
		async destroyContractAddendum(){
			const contract = this.costsTable.contract
			const data = {
				contract_addendum_id: contract.id
			}
			const addendum = await deleteContractAddendum(data)
			if(addendum.code == 200){
				const messageData = {
					message: 'Se ha eliminado correctamente la Tabla de Costo y el Anexo.',
					title: 'Tabla de Costo y Anexo Eliminados',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
				eventBus.$emit('reloadInformation')
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
    openColorPicker(key) {
      this.activeColorKey = key
      this.colorPickerVisible = true
    },

    calcFontColor(backgroundColor) {
      if (!backgroundColor) return '#000';
      let hex = backgroundColor.replace('#', '');
      if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? '#000' : '#fff';
    },

    updateMainItems(items) {
      this.$emit('update:costsTable', {
        ...this.costsTable,
        items
      })
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0
      }).format(value)
    },

		async createTableCostAddendum(){
			if(this.hasAddendumWithCostTable){
				this.$router.push({ hash: '#addendums' })
			}
			else if(this.hasAddendumWithoutCostTable){
				// Encontrar el anexo sin tabla de costo
				const addendum = this.contract.addendums?.find(addendum => addendum.last_status?.status < this.contractStatuses.FIRMADO_CONTRAPARTE)
				if(addendum){
					this.loadingCreateAddendum = true
					// Crear tabla de costo para el anexo existente
					await getProjectCostDetail({project_id: this.project.id, contract_id: addendum.id})
					this.loadingCreateAddendum = false
					this.loading = true
					this.getCosts()
					this.tab = 1
					const messageData = {
						message: 'Se ha creado la tabla de costo para el anexo existente.',
						title: 'Tabla de Costo Creada',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.setMessage(messageData)
				}
			}
			else{
				const data = {
					contract_id: this.contract.id
				}
				this.loadingCreateAddendum = true
				const addendum = await addContractAddendum(data)
				if(addendum.code == 200){
					if(addendum.addendum_notsigned){
						const messageData = {
							message: 'Ya existe un anexo abierto para este proyecto.',
							title: 'Anexos sin finalizar',
							type: 'danger',
							icon: 'mdi-close-octagon',
							color: '#FF1209',
						}
						this.setMessage(messageData)
						return null
					}

					await getProjectCostDetail({project_id: this.project.id, contract_id: addendum.contract_addendum.id})
					eventBus.$emit('reloadInformation', {from: 'addendum-creation-cost-table'})
					this.loadingCreateAddendum = false
					this.loading = true
					
					// this.$router.push({ name: 'ProjectCostBreakdown', params: { id: this.project.id }, query: { contract: addendum.contract_addendum.id } })
					const messageData = {
						message: 'Se ha creado correctamente el anexo.',
						title: 'Anexo Creado',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.setMessage(messageData)
				}
				else{
					const messageData = {
						message: 'Hubo un error en la operación, por favor intenta nuevamente',
						title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
					}
					this.setMessage(messageData)
				}
			}
		},
		setMessage(messageData){
			const data = {
				message: messageData.message,
				title: messageData.title,
				created: new Date(),
				type: messageData.type,
				icon: messageData.icon,
				color: messageData.color,
			}
			this.$store.dispatch('general/addMessage', data)
		},
		handleAddStage() {
			if (this.allowEdit && this.addStage) this.addStage();
		},
		handleAddReception() {
			if (this.allowEdit && this.addReception) this.addReception();
		},
		handleRemoveReception() {
			if (this.allowEdit && this.removeReception) this.removeReception();
		},
		handleAddSpecialty() {
			if (this.allowEdit && this.addSpecialty) this.addSpecialty();
		},
		handleUpdateSurfaceItems(val) {
			if (this.allowEdit && this.updateSurfaceItems) this.updateSurfaceItems(val);
		},
		handleUpdateCostItems(val) {
			if (this.allowEdit && this.updateCostItems) this.updateCostItems(val);
		},
		handleUpdateStage(val, index) {
			if (this.allowEdit && this.updateStage) this.updateStage(val, index);
		},
		handleUpdateReception(val) {
			if (this.allowEdit && this.updateReception) this.updateReception(val);
		},
		handleUpdateSpecialty(val, index) {
			if (this.allowEdit && this.updateSpecialty) this.updateSpecialty(val, index);
		},
  }
}
</script>

<style scoped>
.custom-table-cost table {
  border-collapse: collapse;
}

.custom-table-cost table td,
.custom-table-cost table th {
  border: 1px solid #ccc;
}

.header-rows-custom {
  color: white;
  font-size: 10px;
  font-weight: bold;
}

.header-rows-custom td {
  height: 25px;
}
.force-open-cell{
	pointer-events: all!important;
	opacity: 1!important;
}
td.force-open-cell::before{
	display: none!important;
}
.block-content-background{
	position: relative;
}
/deep/ .blocked-content-cost-table td{
	pointer-events: none;
	position: relative;
}
/deep/.blocked-content-cost-table td::before{
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0.5;
	background: white;
	z-index: 2;
}
.blocked-content{
	opacity: 0.6;
}
.no-costs-table-title-container{
	position: relative;
	width: 100%;
	min-height: 140px;
}
/deep/.no-costs-table-title-container .v-alert{
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	min-height: 140px;
	z-index: 99;
}
</style>
